/*!
 * jins-chainsaw-man.js
 * Vanilla JS — no Swiper, no GSAP, no Lenis (Dawn-safe)
 * p5.js retained for KV logo datamosh effect (canvas-only, no DOM/scroll interaction)
 * -------------------------------------------------------------------
 */
document.addEventListener('DOMContentLoaded', function () {
  var root = document.getElementById('jins-chainsaw-man');
  if (!root) return;

  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var device = window.matchMedia('(min-width: 992px)').matches ? 'PC' : 'SP';

  window.addEventListener('resize', function () {
    device = window.matchMedia('(min-width: 992px)').matches ? 'PC' : 'SP';
  });

  /* =================================================================
     Slider — jt-csm-slider (replaces Swiper)
     ================================================================= */
  var SESSION_KEY = 'jt-csm-slider-state-v1';

  function getSliderState() {
    try {
      return JSON.parse(sessionStorage.getItem(SESSION_KEY)) || { SP: {}, PC: {} };
    } catch (e) {
      return { SP: {}, PC: {} };
    }
  }

  function saveSliderState(id, index) {
    var state = getSliderState();
    if (!state[device]) state[device] = {};
    state[device][id] = index;
    try {
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(state));
    } catch (e) {
      /* sessionStorage unavailable — fail silently */
    }
  }

  function initSlider(el) {
    var id = el.dataset.id;
    var track = el.querySelector('.jt-csm-slider__track');
    var slides = el.querySelectorAll('.jt-csm-slider__slide');
    var prevBtn = el.querySelector('[data-js="carouselArrow"][data-direction="prev"]');
    var nextBtn = el.querySelector('[data-js="carouselArrow"][data-direction="next"]');
    var dotContainer = el.querySelector('.c-carouselDot');
    var slideCount = slides.length;
    if (!track || slideCount === 0) return;

    var state = getSliderState();
    var current = (id && state[device] && state[device][id]) || 0;
    var dots = [];

    function isMobile() {
      return device === 'SP';
    }

    function buildDots() {
      if (!dotContainer || slideCount <= 1) return;
      dotContainer.innerHTML = '';
      dots = [];
      for (var i = 0; i < slideCount; i++) {
        (function (i) {
          var dot = document.createElement('span');
          dot.className = 'c-carouselDot__bullet';
          dot.dataset.index = i;
          dot.addEventListener('click', function () {
            goTo(i);
          });
          dotContainer.appendChild(dot);
          dots.push(dot);
        })(i);
      }
    }

    function updateDots() {
      dots.forEach(function (d, i) {
        d.classList.toggle('c-carouselDot__bullet_active', i === current);
      });
    }

    function updateArrows() {
      if (prevBtn) prevBtn.dataset.disabled = String(current <= 0);
      if (nextBtn) nextBtn.dataset.disabled = String(current >= slideCount - 1);
    }

    function goTo(index) {
      current = Math.max(0, Math.min(index, slideCount - 1));
      if (isMobile()) {
        var slide = slides[current];
        track.scrollTo({
          left: slide.offsetLeft - (track.offsetWidth - slide.offsetWidth) / 2,
          behavior: prefersReducedMotion ? 'auto' : 'smooth'
        });
      } else {
        var pct = current * 100;
        track.style.transform = 'translateX(-' + pct + '%)';
      }
      updateDots();
      updateArrows();
      if (id) saveSliderState(id, current);
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); });

    if (isMobile()) {
      var scrollTimer;
      track.addEventListener('scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var center = track.scrollLeft + track.offsetWidth / 2;
          var closest = 0;
          var dist = Infinity;
          slides.forEach(function (s, i) {
            var d = Math.abs(s.offsetLeft + s.offsetWidth / 2 - center);
            if (d < dist) {
              dist = d;
              closest = i;
            }
          });
          if (closest !== current) {
            current = closest;
            updateDots();
            if (id) saveSliderState(id, current);
          }
        }, 50);
      });
    }

    buildDots();
    goTo(current);
  }

  function initAllSliders() {
    root.querySelectorAll('.jt-csm-slider').forEach(function (el) {
      var obs = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          initSlider(el);
          obs.disconnect();
        }
      }, { rootMargin: '200px 0px', threshold: 0 });
      obs.observe(el);
    });
  }

  /* =================================================================
     Glitch text system — split spans + IntersectionObserver reveal
     ================================================================= */
  function buildGlitchLayers() {
    root.querySelectorAll('.is-glitch.is-multiple').forEach(function (el) {
      if (el.dataset.jtCsmGlitchBuilt) return;
      el.dataset.jtCsmGlitchBuilt = 'true';

      var html = el.innerHTML;
      for (var i = 1; i <= 2; i++) {
        var span = document.createElement('span');
        span.classList.add('is-glitch-item0' + i);
        span.innerHTML = html;
        el.appendChild(span);
      }
    });
  }

  function initGlitchReveal() {
    var isMobile = window.innerWidth <= 991;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
        }
      });
    }, {
      root: null,
      rootMargin: isMobile ? '-15% 0px' : '-25% 0px',
      threshold: 0
    });

    root.querySelectorAll('.js-io').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* =================================================================
     Product title split-into-spans + flicker-in reveal
     (Replaces GSAP repeat/yoyo tween with CSS keyframe + randomized
     custom properties, triggered per-title on first intersection)
     ================================================================= */
  function splitTitleIntoSpans() {
    root.querySelectorAll('.jt-csm-products__title').forEach(function (title) {
      if (title.dataset.jtCsmSplit) return;
      title.dataset.jtCsmSplit = 'true';
      var text = title.textContent.trim();
      var html = text.split('').map(function (ch) {
        if (ch === ' ') return '<span data-jt-csm-linebreak></span>';
        return '<span>' + ch + '</span>';
      }).join('');
      title.innerHTML = html;
    });
  }

  function initTitleFlicker() {
    var observer = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var titleWrapper = entry.target;
        var title = titleWrapper.querySelector('.jt-csm-products__title');
        if (!title) return;

        title.classList.add('is-inview');
        title.classList.add('jt-csm-is-settled');

        obs.unobserve(titleWrapper);
      });
    }, { threshold: 0.5 });

    root.querySelectorAll('.jt-csm-products__items').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* =================================================================
     KV logo — p5.js pixel datamosh effect
     Adapted from JP source (canvas-only, instance mode, no global scope pollution)
     ================================================================= */
  var kvLogoSketchClass = (function () {
    function DatamoshLogo(imgOrigin, w, h, p) {
      this.p = p;
      this.channelLen = 4;
      this.width = w;
      this.height = h;
      this.imgOrigin = imgOrigin;
      this.imgOrigin.resize(w, h);
      this.imgOrigin.loadPixels();
      this.copyData = new Uint8ClampedArray(this.imgOrigin.pixels);
      this.flowLineImgs = [];
      this.shiftLineImgs = [];
      this.shiftRGBs = [];
      this.scatImgs = [];
      this.throughFlag = true;

      this.flowLineImgs.push({
        pixels: null,
        t1: Math.floor(p.random(0, 1000)),
        speed: Math.floor(p.random(4, 24)),
        randX: Math.floor(p.random(24, 80))
      });
      for (var s = 0; s < 6; s++) this.shiftLineImgs.push(null);
      this.shiftRGBs.push(null);
      for (var o = 0; o < 3; o++) this.scatImgs.push({ img: null, x: 0, y: 0 });
    }

    DatamoshLogo.prototype.replaceData = function (target, data) {
      for (var r = 0; r < target.height; r++) {
        for (var i = 0; i < target.width; i++) {
          var n = (r * target.width + i) * this.channelLen;
          target.pixels[n] = data[n];
          target.pixels[n + 1] = data[n + 1];
          target.pixels[n + 2] = data[n + 2];
          target.pixels[n + 3] = data[n + 3];
        }
      }
      target.updatePixels();
    };

    DatamoshLogo.prototype.flowLine = function (target, e) {
      var r = new Uint8ClampedArray(target.pixels);
      e.t1 %= target.height;
      e.t1 += e.speed;
      var i = Math.floor(e.t1);
      for (var n = 0; n < target.height; n++) {
        if (i === n) {
          for (var s = 0; s < target.width; s++) {
            var a = (n * target.width + s) * this.channelLen;
            r[a] = target.pixels[a] + e.randX;
            r[a + 1] = target.pixels[a + 1] + e.randX;
            r[a + 2] = target.pixels[a + 2] + e.randX;
            r[a + 3] = target.pixels[a + 3];
          }
        }
      }
      return r;
    };

    DatamoshLogo.prototype.shiftLine = function (target) {
      var e = new Uint8ClampedArray(target.pixels);
      var h = target.height;
      var i = Math.floor(this.p.random(0, h));
      var n = i + Math.floor(this.p.random(1, h - i));
      var s = this.channelLen * Math.floor(this.p.random(-2, 2));
      for (var a = 0; a < h; a++) {
        if (a > i && a < n) {
          for (var o = 0; o < target.width; o++) {
            var u = (a * target.width + o) * this.channelLen;
            var hIdx = u + s;
            var l = u + 1 + s;
            var f = u + 2 + s;
            e[u] = target.pixels[hIdx] || 0;
            e[u + 1] = target.pixels[l] || 0;
            e[u + 2] = target.pixels[f] || 0;
            e[u + 3] = target.pixels[u + 3];
          }
        }
      }
      return e;
    };

    DatamoshLogo.prototype.shiftRGB = function (target) {
      var e = new Uint8ClampedArray(target.pixels);
      var r = (Math.floor(this.p.random(-6, 6)) * target.width + Math.floor(this.p.random(-6, 6))) * this.channelLen;
      var g = (Math.floor(this.p.random(-6, 6)) * target.width + Math.floor(this.p.random(-6, 6))) * this.channelLen;
      var b = (Math.floor(this.p.random(-6, 6)) * target.width + Math.floor(this.p.random(-6, 6))) * this.channelLen;
      for (var s = 0; s < target.height; s++) {
        for (var a = 0; a < target.width; a++) {
          var o = (s * target.width + a) * this.channelLen;
          var uIdx = (o + r) % target.pixels.length;
          var hIdx = (o + 1 + g) % target.pixels.length;
          var lIdx = (o + 2 + b) % target.pixels.length;
          e[o] = target.pixels[uIdx];
          e[o + 1] = target.pixels[hIdx];
          e[o + 2] = target.pixels[lIdx];
          e[o + 3] = target.pixels[o + 3];
        }
      }
      return e;
    };

    DatamoshLogo.prototype.getRandomRectImg = function (target) {
      var e = Math.floor(this.p.random(0, target.width - 12));
      var r = Math.floor(this.p.random(0, target.height - 20));
      var i = Math.floor(this.p.random(15, target.width - e));
      var n = Math.floor(this.p.random(1, 20));
      var s = target.get(e, r, i, n);
      s.loadPixels();
      return s;
    };

    DatamoshLogo.prototype.show = function () {
      var self = this;
      this.replaceData(this.imgOrigin, this.copyData);

      if (Math.floor(this.p.random(100)) > 80 && this.throughFlag) {
        this.throughFlag = false;
        setTimeout(function () {
          self.throughFlag = true;
        }, Math.floor(this.p.random(40, 400)));
      }

      if (!this.throughFlag) {
        this.p.push();
        this.p.translate((this.p.width - this.imgOrigin.width) / 2, (this.p.height - this.imgOrigin.height) / 2);
        this.p.image(this.imgOrigin, 0, 0);
        this.p.pop();
        return;
      }

      this.flowLineImgs.forEach(function (e, i, arr) {
        arr[i].pixels = self.flowLine(self.imgOrigin, e);
        if (arr[i].pixels) self.replaceData(self.imgOrigin, arr[i].pixels);
      });

      this.shiftLineImgs.forEach(function (e, i, arr) {
        if (Math.floor(self.p.random(100)) > 75) {
          arr[i] = self.shiftLine(self.imgOrigin);
          self.replaceData(self.imgOrigin, arr[i]);
        } else if (arr[i]) {
          self.replaceData(self.imgOrigin, arr[i]);
        }
      });

      this.shiftRGBs.forEach(function (e, i, arr) {
        if (Math.floor(self.p.random(100)) > 85) {
          arr[i] = self.shiftRGB(self.imgOrigin);
          self.replaceData(self.imgOrigin, arr[i]);
        }
      });

      this.p.push();
      this.p.translate((this.p.width - this.imgOrigin.width) / 2, (this.p.height - this.imgOrigin.height) / 2);
      this.p.image(this.imgOrigin, 0, 0);
      this.p.pop();

      this.scatImgs.forEach(function (e) {
        self.p.push();
        self.p.translate((self.p.width - self.imgOrigin.width) / 2, (self.p.height - self.imgOrigin.height) / 2);
        if (Math.floor(self.p.random(100)) > 90) {
          e.x = Math.floor(self.p.random(-0.3 * self.imgOrigin.width, 0.7 * self.imgOrigin.width));
          e.y = Math.floor(self.p.random(-0.1 * self.imgOrigin.height, self.imgOrigin.height));
          e.img = self.getRandomRectImg(self.imgOrigin);
        }
        if (e.img) self.p.image(e.img, e.x, e.y);
        self.p.pop();
      });
    };

    return DatamoshLogo;
  })();

  var kvLogoInstance = null;

  function initKvLogo() {
    var mount = document.getElementById('jt-csm-kv-logo');
    if (!mount || typeof p5 === 'undefined') return;
    if (prefersReducedMotion) return;

    var logoUrl = 'https://cdn.shopify.com/s/files/1/0562/8903/4283/files/jins-csm-kv-logo.png';

    var sketch = function (p) {
      var effect;
      var ready = false;

      p.setup = function () {
        var w = mount.clientWidth;
        var h = mount.clientHeight;
        p.createCanvas(w, h).parent(mount);
        p.pixelDensity(1);
        p.frameRate(48);
        p.loadImage(logoUrl, function (img) {
          // Fit image proportionally within canvas (contain, not stretch)
          var imgRatio = img.width / img.height;
          var canvasRatio = w / h;
          var fitW, fitH;
          if (imgRatio > canvasRatio) {
            fitW = w;
            fitH = Math.round(w / imgRatio);
          } else {
            fitH = h;
            fitW = Math.round(h * imgRatio);
          }
          effect = new kvLogoSketchClass(img, fitW, fitH, p);
          ready = true;
          // Canvas is ready — hide the static fallback img
          var fallback = mount.querySelector('.jt-csm-kv__logo-fallback');
          if (fallback) fallback.classList.add('is-hidden');
        });
      };

      p.draw = function () {
        p.clear();
        if (ready) effect.show();
      };
    };

    if (kvLogoInstance) {
      kvLogoInstance.remove();
      kvLogoInstance = null;
    }
    kvLogoInstance = new p5(sketch, 'jt-csm-kv-logo');
  }

  function initKvLogoLazy() {
    // p5.js loads via defer before this script, so it's guaranteed available.
    // Call immediately — no IntersectionObserver or window.load delay needed.
    initKvLogo();
  }

  /* =================================================================
     Back to top button
     ================================================================= */
  function initBackButton() {
    var btn = document.getElementById('jt-csm-backBtn');
    if (!btn) return;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      window.scrollTo({ top: 0, left: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
    });
  }

  /* =================================================================
     Loading screen
     ================================================================= */
  function initLoading() {
    var loading = root.querySelector('.jt-csm-loading');
    if (!loading) return;
    requestAnimationFrame(function () {
      loading.classList.add('is-active');
    });
    setTimeout(function () {
      loading.style.display = 'none';
    }, 1200);
  }

  /* =================================================================
     Browser detection — adds is-chrome or is-safari class to each
     product title, enabling the filter enhancement for difference blend
     ================================================================= */
  function detectBrowser() {
    var ua = navigator.userAgent;
    var supportsP3 = window.matchMedia('(color-gamut: p3)').matches;
    var isChrome = /Chrome/.test(ua) && !/Edg/.test(ua) && !/OPR/.test(ua) && supportsP3;
    var isSafari = /Safari/.test(ua) && !/Chrome/.test(ua) && supportsP3;
    if (!isChrome && !isSafari) return;
    var cls = isChrome ? 'is-chrome' : 'is-safari';
    root.querySelectorAll('.jt-csm-products__title').forEach(function (title) {
      title.classList.add(cls);
    });
  }

  /* =================================================================
     Init
     ================================================================= */
  detectBrowser();
  splitTitleIntoSpans();
  buildGlitchLayers();
  initGlitchReveal();
  initTitleFlicker();
  initAllSliders();
  initKvLogoLazy();
  initBackButton();
  initLoading();
});
